import {
  FOC_TOUR_LABEL_PLANNING_P_COMMAND_STAFF,
  focFeedbackPopoverHtml,
} from '../focTourFeedback';
import {
  FOC_REQUIRED_DISPOSITION,
  focPlanningPRequirement,
  focPlanningPTourNavVisible,
  type FocPlanningPTourStepDef,
} from './focPlanningPTourTypes';
import { FOC_PLANNING_P_COMMAND_STAFF_TOUR_HREF } from './focPlanningPTourRegistry';

export { FOC_PLANNING_P_COMMAND_STAFF_TOUR_HREF, focPlanningPTourNavVisible };

/** Phase index 1 = Command & General Staff Meeting; 6 = IAP Prep & Approval. */
export const FOC_PLANNING_P_COMMAND_STAFF_TOUR_STEPS: FocPlanningPTourStepDef[] =
  [
    {
      id: 'sectionIntro',
      phaseIndex: 1,
      title: '10.3 Command and General Staff Meeting',
      description:
        'The Command and General Staff Meeting aligns strategy, confirms required IAP work, identifies deliverable ownership, records decisions, and establishes follow-on actions.',
    },
    focPlanningPRequirement({
      id: 'pp004',
      requirementId: 'FOC-PP-004',
      name: 'Command and General Staff Meeting Workspace',
      disposition: FOC_REQUIRED_DISPOSITION,
      phaseIndex: 1,
      tour: 'planning-agenda',
      showAgenda: true,
      description:
        'PRATUS provides an IMH-aligned Command and General Staff Meeting workspace where Incident Command, Command Staff, and Section Chiefs align strategy, confirm required IAP work, identify deliverable ownership, record decisions, and establish follow-on actions.',
    }),
    focPlanningPRequirement({
      id: 'pp004a',
      requirementId: 'FOC-PP-004a',
      name: 'Required IAP Components',
      disposition: FOC_REQUIRED_DISPOSITION,
      phaseIndex: 1,
      tour: 'planning-stepper',
      description:
        'The Command and General Staff Meeting workflow includes an agenda-linked process to identify required IAP components early in the operational-period planning cycle. Component selection continues into IAP preparation.',
    }),
    focPlanningPRequirement({
      id: 'pp004b',
      requirementId: 'FOC-PP-004b',
      name: 'IAP Component Selection',
      disposition: FOC_REQUIRED_DISPOSITION,
      phaseIndex: 6,
      tour: 'iap-components',
      widget: 'incidentActionPlan',
      description:
        'PRATUS provides a Coast Guard-informed default list of common IAP components with required/not-required selection, optional components, incident-specific supplemental products, and authorized custom entries on the IAP cover sheet / attachment manifest.',
    }),
    focPlanningPRequirement({
      id: 'pp004c',
      requirementId: 'FOC-PP-004c',
      name: 'Component Continuity',
      disposition: FOC_REQUIRED_DISPOSITION,
      phaseIndex: 6,
      tour: 'planning-form-card',
      widget: 'incidentActionPlan',
      description:
        'Selected IAP components populate the IAP component tracker, inform the IAP cover sheet and assembly workflow, and support assignment of responsible owners through the IAP preparation path.',
    }),
    focPlanningPRequirement({
      id: 'pp005',
      requirementId: 'FOC-PP-005',
      name: 'Command and General Staff Deliverables',
      disposition: FOC_REQUIRED_DISPOSITION,
      phaseIndex: 1,
      tour: 'ics202-card',
      widget: 'incidentObjectives',
      description:
        'The meeting workflow supports review and assignment of incident objectives, priorities, key decisions, limitations, constraints, Critical Information Requirements, resource-ordering considerations, safety and security issues, organization, performance expectations, and required IAP components — starting from ICS 202 and open actions.',
    }),
    {
      id: 'focFeedback',
      title: 'FOC Feedback Notes',
      description: focFeedbackPopoverHtml(
        FOC_TOUR_LABEL_PLANNING_P_COMMAND_STAFF
      ),
    },
  ];

export function focPlanningPCommandStaffTourStepIds(): string[] {
  return FOC_PLANNING_P_COMMAND_STAFF_TOUR_STEPS.map((step) => step.id);
}
